import { Component } from 'react';

class TournamentLeaderboardEntry extends Component {
  printEntry() {
    const { entry, titles } = this.props;

    const entryElement = [];
    for (let i = 0; i < titles.length; i++) {
      const currentTitle = titles[i];
      let value = entry[currentTitle.field];
      if (currentTitle.field === 'rank') {
        if (value === 1) {
          value = <i className="fa fa-trophy tournament_leaderboard_first_place"></i>;
        } else if (value === 2) {
          value = <i className="fa fa-trophy tournament_leaderboard_second_place"></i>;
        } else if (value === 3) {
          value = <i className="fa fa-trophy tournament_leaderboard_third_place"></i>;
        } else {
          value = <span className="tournament_entry_rank">{value}</span>;
        }
      }

      if (currentTitle.field === 'score') {
        let elementClass = 'tournament_entry_score';
        if (entry.rank === 1) {
          elementClass += ' first';
        } else if (entry.rank === 2) {
          elementClass += ' second';
        } else if (entry.rank === 3) {
          elementClass += ' third';
        }

        value = <span className={elementClass}>{value}</span>;
      }

      entryElement.push(<td>{value}</td>);
    }

    return entryElement;
  }

  render() {
    const { entry } = this.props;

    let elementClass = 'tournament_leaderboard_entry';
    if (entry.rank === 1) {
      elementClass += ' first';
    } else if (entry.rank === 2) {
      elementClass += ' second';
    } else if (entry.rank === 3) {
      elementClass += ' third';
    }

    return <tr className={elementClass}>{this.printEntry()}</tr>;
  }
}

export default TournamentLeaderboardEntry;
